import React from 'react';
import { connect } from 'react-redux';
import AuthHome from '../../components/Authentication/AuthHome/AuthHome';
import AuthLogin from '../../components/Authentication/AuthLogin/AuthLogin';
import AuthOTP from '../../components/Authentication/AuthOTP/AuthOTP';
import AuthForgotPassword from '../../components/Authentication/AuthForgotPassword/AuthForgotPassword';
import AuthResetPasswordLink from '../../components/Authentication/AuthResetPasswordLink/AuthResetPasswordLink';
import AuthSetPassword from '../../components/Authentication/AuthSetPassword/AuthSetPassword';
import AuthResetCompleted from '../../components/Authentication/AuthResetCompleted/AuthResetCompleted';
import AuthCompleted from '../../components/Authentication/AuthCompleted/AuthCompleted';

const authentication = (props) => {
        switch(props.view) {
            case 'home':
                return <div className={`p-0 phone-p-8 u-height-100Percent`}><AuthHome/></div>;
            case 'login':
                return <div className={`p-0 phone-p-8 u-height100Percent`}><AuthLogin/></div>;
            case 'otp':
                return <div className={`p-0 phone-p-8 u-height100Percent`}><AuthOTP/></div>;
            case 'forgotPassword':
                return <div className={`p-0 phone-p-8 u-height100Percent`}><AuthForgotPassword/></div>;
            case 'forgotPasswordLink':
                return <div className={`p-0 phone-p-8 u-height100Percent`}><AuthResetPasswordLink/></div>;
            case 'setPassword':
                return <div className={`p-0 phone-p-8 u-height100Percent`}><AuthSetPassword/></div>;
            case 'resetCompleted':
                return <div className={`p-0 phone-p-8 u-height100Percent`}><AuthResetCompleted/></div>;
            case 'accountCreated':
                return <div className={`p-0 phone-p-8 u-height100Percent`}><AuthCompleted/></div>;
            default:
                return <AuthHome/>;
        }
}

const mapStateToProps = state => {
    return {
        view: state.auth.view
    }
}

export default connect(mapStateToProps)(authentication);


// WEBPACK FOOTER //
// ./src/containers/Authentication/Authentication.js